import React, { useState, useEffect } from 'react'
import { logEvent, getTeamIc } from '../../Utils'
import { TeamButton } from './TeamButton'
import { teamsBasicArray } from '../../Constant/team'
import { SectionHeading } from '../Headers'
import { Box } from '../Layout'
import { DEFAULT_EXTRA_LOGIN_FIELDS, updateFavoriteTeam } from '../../Api'
import { useAuthContext } from '../../Context'
import { SubTextCon, TeamSelectCon, WelcomeCon } from './styles'
import { Img } from '../Image/Img'
import { Desc } from '../Typography/Text.styles'
import { colors } from '../consts'

export const FavoriteTeam: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isAnonymous, isLoggedIn, login, favTeam, updateFavsInState } = useAuthContext()
  const [favoriteTeam, setFavoriteTeam] = useState<string | null | undefined>(favTeam)
  const [showTeamFav, setShowTeamFav] = useState<boolean>(false)

  useEffect(() => {
    if (isAnonymous || !favTeam) return
    const pending = sessionStorage.getItem('pending_team_fav')
    if (!pending) {
      setFavoriteTeam(favTeam)
    } else {
      sessionStorage.removeItem('pending_team_fav')
      updateFavTeam(pending)
    }
  }, [isLoggedIn, favTeam])

  const log = (event: string) => {
    logEvent(event, {
      favorite_team: favoriteTeam,
      auth_status: isLoggedIn && !isAnonymous ? 'logged_in' : 'no_auth',
    })
  }
  const updateFavTeam = async (teamName: string) => {
    if (isAnonymous) {
      log('fav_team_click_no_auth')
      sessionStorage.setItem('pending_team_fav', teamName)
      sessionStorage.setItem('login_text', 'Login to save your favorite team')
      return login(DEFAULT_EXTRA_LOGIN_FIELDS)
    }
    if (teamName === favTeam) return
    const { success, team } = await updateFavoriteTeam(teamName)
    if (!success || !team) return alert('Could not add team to favorites. Try again')

    setFavoriteTeam(team)
    log('fav_team_click')
    setShowTeamFav(true)
    setTimeout(() => {
      updateFavsInState('favTeam', [], team)
      setShowTeamFav(false)
    }, 2000)
  }

  return (
    <>
      {showTeamFav && favoriteTeam && (
        <>
          <Box boxColor="dark">
            <WelcomeCon>
              <h2>Welcome To The Team!</h2>
              <Img src={getTeamIc(favoriteTeam)} alt={`${favoriteTeam} Logo`} />
            </WelcomeCon>
          </Box>
        </>
      )}

      {!showTeamFav && !favoriteTeam && (
        <>
          <Box boxColor="dark">
            <SectionHeading lowMargin headingColor="light">
              <strong>Pledge team allegiance</strong>
            </SectionHeading>
            <SubTextCon>
              <Desc color={colors.white} vertMargins={2}>
                Support your team | Keep up with news | Unify your team's fanbase
              </Desc>
            </SubTextCon>
            <TeamSelectCon>
              {teamsBasicArray.map((tm) => (
                <TeamButton
                  key={tm.officialId}
                  team={tm}
                  updateFavTeam={updateFavTeam}
                />
              ))}
            </TeamSelectCon>
          </Box>
        </>
      )}
    </>
  )
}
